// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Sp9bN","header_sub_container":"Header_header_sub_container__vCKFe","tab":"Header_tab__DQZYJ","text":"Header_text__pncGi"};